import gql from 'graphql-tag';

const CREATE_EXPENSE_INVENTORY = gql`
  mutation createExpenseInventory(
    $caseId: String
    $caseExternalId: String
    $salesRepId: String!
    $writeOffType: String!
    $accountId: String
    $shipToId: String
    $usageDate: Date
    $usedInPatientCare: Boolean
    $marketingCollaboration: Boolean
    $doctorName: String
    $facilityNameOrLocation: String
  ) {
    createExpenseInventory(
      caseId: $caseId
      caseExternalId: $caseExternalId
      salesRepId: $salesRepId
      writeOffType: $writeOffType
      accountId: $accountId
      shipToId: $shipToId
      usageDate: $usageDate
      usedInPatientCare: $usedInPatientCare
      marketingCollaboration: $marketingCollaboration
      doctorName: $doctorName
      facilityNameOrLocation: $facilityNameOrLocation
    ) {
      message
      externalId
      sfid
    }
  }
`;

export default CREATE_EXPENSE_INVENTORY;
